if (!customElements.get("collection-banner-match-bg")) {
  class CollectionBannerMatchBg extends HTMLElement {
    connectedCallback() {
      if (this.dataset.matchBg !== "true") return;
      if (this.dataset.bgOverride) {
        this.style.setProperty("--collection-banner-match-bg", this.dataset.bgOverride);
        this.classList.add("is-matched");
        return;
      }

      const img = this.querySelector("img");
      if (!img) return;

      if (img.complete && img.naturalWidth) {
        this.sampleImage(img);
      } else {
        img.addEventListener("load", () => this.sampleImage(img), { once: true });
      }
    }

    sampleImage(img) {
      try {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d", { willReadFrequently: true });
        if (!ctx) return;

        const sampleWidth = 24;
        const sampleHeight = 64;
        canvas.width = sampleWidth;
        canvas.height = sampleHeight;

        const sourceW = Math.max(1, Math.floor(img.naturalWidth * 0.04));
        const sourceH = img.naturalHeight;
        const position = this.dataset.imagePosition || "right";
        const sourceX =
          position === "left"
            ? Math.max(0, img.naturalWidth - sourceW)
            : 0;

        ctx.drawImage(
          img,
          sourceX,
          0,
          sourceW,
          sourceH,
          0,
          0,
          sampleWidth,
          sampleHeight
        );

        const { data } = ctx.getImageData(0, 0, sampleWidth, sampleHeight);
        let r = 0;
        let g = 0;
        let b = 0;
        let count = 0;

        for (let i = 0; i < data.length; i += 4) {
          const alpha = data[i + 3];
          if (alpha < 200) continue;
          r += data[i];
          g += data[i + 1];
          b += data[i + 2];
          count += 1;
        }

        if (!count) return;

        r = Math.round(r / count);
        g = Math.round(g / count);
        b = Math.round(b / count);

        this.style.setProperty(
          "--collection-banner-match-bg",
          `rgb(${r}, ${g}, ${b})`
        );
        this.classList.add("is-matched");
      } catch (error) {
        // Canvas can fail on CORS; leave the color scheme background.
      }
    }
  }

  customElements.define("collection-banner-match-bg", CollectionBannerMatchBg);
}
